module.exports = __webpack_public_path__ + "img/13.a690a4be.jpg";